// extracted by mini-css-extract-plugin
export default {"expandable":"Expandable_expandable__30fqa","expanded":"Expandable_expanded__e0y3t"};